module.exports = __webpack_public_path__ + "img/07-img.ed5954e2.jpg";